<template>
  <div v-if="enableModal">
    <b-modal size="lg" :title="selectedAstuce.titre" id="modal-astuce" v-model="modalShow" ref="modal-astuce">
      <b-card>
        <span v-html="selectedAstuce.texte"></span>
      </b-card>
      <b-form-checkbox v-model="isAstuceEnabled" @change="changeAstuceVisiblity" name="check-button" switch
                       class="col-md-12 mt-3">
        Ne plus afficher d'astuce à la connexion
      </b-form-checkbox>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            v-if="astuces.length > 1"
            variant="primary"
            class="float-right ml-2"
            @click="nextAstuce">
            Astuce suivante
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="closeModal">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken, getUser} from '@/utils/auth';
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "AstuceModal",
    data() {
      return {
        astuces: [],
        modalShow: false,
        selectedAstuce: {
          titre: '',
          texte: '',
        },
        enableModal: false,
        isAstuceEnabled: false,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    mounted() {
      if(this.$store.getters.getIsFromLogin) {
        this.getEnableAstuce();
        this.getRandomAstucesByProfile();
      } else {
      }
    },
    beforeDestroy() {
      this.$store.dispatch('setIsFromLogin', false);
    },
    methods: {
      openModal() {
        this.modalShow = true;
      },
      closeModal() {
        this.modalShow = false;
      },
      getRandomAstucesByProfile() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/administration/astuces/by-profile")
          .then(response => {
            this.astuces = response.data.astuces;
            if (this.astuces.length > 0) {
              this.selectedAstuce = this.astuces[Math.floor(Math.random() * this.astuces.length)];
              this.openModal();
            }
          })
          .catch(error => console.log(error))
          .finally(() => this.$store.commit('IS_LOADING', false));

      },
      nextAstuce() {
        this.selectedAstuce = this.astuces[Math.floor(Math.random() * this.astuces.length)]
      },
      async getEnableAstuce() {
        // const runtimeConfig = await fetch('/environment.json');
        // runtimeConfig.json()
        //   .then(data => {
        //     if (!isEmpty(data.enable_astuce)) {
        //       this.enableModal = data.enable_astuce;
        //     } else {
        //       this.enableModal = false;
        //     }
        //   })
        this.enableModal = false;
      },
      changeAstuceVisiblity() {
        let dataPost = {};
        dataPost.is_astuce_enabled = this.isAstuceEnabled;
        this.$axios
          .put("/administration/astuces/enable-astuce", dataPost)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
          });
      },
    }
  }
</script>
